import { styled } from 'styled-components';
import { Media } from '../../../../../theme/Media.js';
export const TableCardHeaderWrapper = styled.div `
  background: ${({ theme }) => theme.colors.grey00_1};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
  box-sizing: border-box;
  padding: 24px 24px 0;
  overflow: hidden;

  @media ${Media.xsMax} {
    padding: 16px 16px 0;
  }
`;
export const TableCardHeaderTitleWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 0 0 24px;

  @media ${Media.xsMax} {
    padding: 0 0 16px;
    flex-direction: column;
  }
`;
export const TableCardHeaderActionWrapper = styled.div `
  display: flex;
  gap: 12px;

  @media ${Media.xsMax} {
    flex-direction: column;
    width: 100%;

    & > * > button {
      width: 100%;
    }
  }
`;
export const TableCardHeaderTabsContainer = styled.div `
  @media ${Media.smMin} {
    padding: 0 16px;
  }
  background-color: ${({ theme }) => theme.colors.grey00_1};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
`;
